import React, { Component } from 'react';
import './css/App.css';

// Component Imports
import NavBar from './Components/Nav';
import Home from './Components/Home';

class App extends Component {
  render() {
    return (
      <div className="App">
          <NavBar />
          <Home />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js